import './chart_view.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Charts'

CHARTS = CustomerVisualMode.Charts

class CustomerVisualMode.Charts.FirstHumanResponseSinceFirstHumanAssignationChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/first_human_response_since_first_human_assignation_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'wom_service_level'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.first_human_response_since_first_human_assignation.title')
    description = I18n.t('customer_visual_mode.charts.first_human_response_since_first_human_assignation.title')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html(@template)
    @$el.find('.whatsapp-metrics').append(@_whatsappMetricsView().render().el)
    @$el.find('.other-metrics').append(@_otherTicketsMetricsView().render().el)
    @$el.find('.title').addClass('wom-widget-title')
    @

  _whatsappMetricsView: ->
    new CustomerVisualMode.Charts.AverageTimeChartView({
      sla: @data.sla.whatsapp_human_assigned_responded,
      compliesWithSlaCount: @data.sla_fulfilling_whatsapp_first_human_response_since_first_human_assignation,
      uncompliesWithSlaCount: @data.sla_unfulfilling_whatsapp_first_human_response_since_first_human_assignation,
      averageTimeInSeconds: @data.average_whatsapp_first_human_response_since_first_human_assignation,
      translations: {
        title: I18n.t('customer_visual_mode.charts.first_human_response_since_first_human_assignation.whatsapp'),
        sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
        total: I18n.t('customer_visual_mode.charts.first_metrics.total')
      },
      widgetName: @constructor.NAME
    })

  _otherTicketsMetricsView: ->
    new CustomerVisualMode.Charts.AverageTimeChartView({
      sla: @data.sla.social_media_human_assigned_responded,
      compliesWithSlaCount: @data.sla_fulfilling_first_human_response_since_first_human_assignation,
      uncompliesWithSlaCount: @data.sla_unfulfilling_first_human_response_since_first_human_assignation,
      averageTimeInSeconds: @data.average_social_media_first_human_response_since_first_human_assignation,
      translations: {
        title: I18n.t('customer_visual_mode.charts.first_human_response_since_first_human_assignation.other'),
        sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
        total: I18n.t('customer_visual_mode.charts.first_metrics.total')
      },
      widgetName: @constructor.NAME
    })
